"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TitleSection_1 = __importDefault(require("@/components/DynamicTable/TitleSection"));
function ProductTabletTitleSectionView({ onAddRow }) {
    return (react_1.default.createElement(TitleSection_1.default, { title: "Product List", onAddRow: onAddRow, addRowButtonLabel: "Add product" }));
}
exports.default = ProductTabletTitleSectionView;
